"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPascalCase = void 0;
/**
 * @summary Converts a string to `PascalCase`.
 *
 * Converts a string to `PascalCase`.
 *
 * @param {string} str
 * @returns {string}
 *
 * @example
 * const key = toPascalCase('my-identifier');
 *
 * @see https://stackoverflow.com/a/53952925
 */
function toPascalCase(str) {
    return str
        .replace(/[-_]+/g, ' ')
        .replace(/[^\w\s]/g, '')
        .replace(/\s+(.)(\w+)/g, ($1, $2, $3) => `${$2.toUpperCase()}${$3.toLowerCase()}`)
        .replace(/\s/g, '')
        .replace(/\w/, (s) => s.toUpperCase());
}
exports.toPascalCase = toPascalCase;
